module.exports = "https://r.nearpod.com/assets/media/image/GS-tooltip-header-9df1ba016cae4eae4ce48bc3e418d250.svg";